module.exports = __webpack_public_path__ + "img/gentlemen-club-carousel-15.e9a21488.png";